// src/tenantAdmin/pages/CompanyPlansPage.jsx
//
// The "Piani" tab: the standalone plans screen in its tab variant. Rendered only
// under ActiveCompanyGuard — Piani acts on the ACTIVE workspace's company (the
// billing API keys every call on it), which the guard has proven is the console's.
// Cancel and card-update returns come back HERE (basePath); the success returns
// stay on /billing/return and /credits?topup=done, which own the polling.
import React from 'react';
import Piani from '../../sections/Piani.jsx';

export default function CompanyPlansPage() {
  return (
    <Piani
      variant="tab"
      basePath="/tenant-admin/manage/plans"
      billingDetailsTo="/tenant-admin/manage/company" />
  );
}
